<template>
  <div class="d-flex align-items-center">
    <p class="mb-0">Journalistes</p>
    <div class="form-check form-switch mx-3">
      <input @change="(event) => $emit('on-type-switch', event)" type="checkbox" class="form-check-input border"
        id="journalist">
    </div>
    <p class="mb-0">Partenaires</p>
  </div>

  <div class="mt-3" v-if="isPartnerChecked === false">
    <div class="form-check form-check-inline">
      <input @change="(event) => $emit('on-directory-filter', event)" class="form-check-input border"
        :value="FilterType.ALL" type="radio" name="theme" :id="FilterType.ALL" checked>
      <label class="form-check-label" :for="FilterType.ALL">{{ FilterType.ALL }}</label>
    </div>

    <div class="form-check form-check-inline">
      <input @change="(event) => $emit('on-directory-filter', event)" class="form-check-input border"
        :value="FilterType.ACT_SOCIALE" type="radio" name="theme" :id="FilterType.ACT_SOCIALE">
      <label class="form-check-label" :for="FilterType.ACT_SOCIALE">{{ FilterType.ACT_SOCIALE }}</label>
    </div>

    <div class="form-check form-check-inline">
      <input @change="(event) => $emit('on-directory-filter', event)" class="form-check-input border"
        :value="FilterType.FORM_PRO" type="radio" name="theme" :id="FilterType.FORM_PRO">
      <label class="form-check-label" :for="FilterType.FORM_PRO">{{ FilterType.FORM_PRO }}</label>
    </div>
    <div class="form-check form-check-inline">
      <input @change="(event) => $emit('on-directory-filter', event)" class="form-check-input border"
        :value="FilterType.PROT_SOCIALE" type="radio" name="theme" :id="FilterType.PROT_SOCIALE">
      <label class="form-check-label" :for="FilterType.PROT_SOCIALE">{{ FilterType.PROT_SOCIALE }}</label>
    </div>

    <div class="form-check form-check-inline">
      <input @change="(event) => $emit('on-directory-filter', event)" class="form-check-input border"
        :value="FilterType.TRAV_EMP_DIAL_SOCIAL" type="radio" name="theme" :id="FilterType.TRAV_EMP_DIAL_SOCIAL">
      <label class="form-check-label" :for="FilterType.TRAV_EMP_DIAL_SOCIAL">{{ FilterType.TRAV_EMP_DIAL_SOCIAL }}</label>
    </div>

    <div class="form-check form-check-inline">
      <input @change="(event) => $emit('on-directory-filter', event)" class="form-check-input border"
        :value="FilterType.ACTU_SOC_GENERALISTE" type="radio" name="theme" :id="FilterType.ACTU_SOC_GENERALISTE">
      <label class="form-check-label" :for="FilterType.ACTU_SOC_GENERALISTE">
        {{ FilterType.ACTU_SOC_GENERALISTE }}
      </label>
    </div>

    <div class="form-check form-check-inline">
      <input @change="(event) => $emit('on-directory-filter', event)" class="form-check-input border" type="radio"
        name="theme" :value="FilterType.RH" :id="FilterType.RH">
      <label class="form-check-label" :for="FilterType.RH">{{ FilterType.RH }}</label>
    </div>
  </div>
</template>

<script>
export const FilterType = {
  ALL: 'Tous',
  RH: 'Ressources humaines et management',
  ACTU_SOC_GENERALISTE: 'Actualité sociale généraliste',
  TRAV_EMP_DIAL_SOCIAL: 'Travail, emploi et dialogue social',
  PROT_SOCIALE: 'Protection sociale',
  ACT_SOCIALE: 'Action sociale',
  FORM_PRO: 'Formation professionnelle'
}

export default {
  name: 'DirectoryFilters',
  emits: ['on-directory-filter', 'on-type-switch'],

  props: {
    isPartnerChecked: Boolean
  },

  data() {
    return {
      FilterType
    }
  },
}
</script>
